import logo from "../../assets/img/logos/logo-grupo-monaco.jpg";
import { StyledEngineProvider, styled } from "@mui/material/styles";
import { Button, Container, TextField, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import { Fragment } from "react";

const LoginTextField = styled(TextField)({
	input: {
		color: "#292929",
		"&:-webkit-autofill": {
			WebkitBoxShadow: "0 0 0 1000px #fdfeff inset",
			WebkitTextFillColor: "#292929 !important",
		},
	},
	InputLabelProps: {
		color: "#292929",
		fontFamily: "Quicksand",
	},
	"&:-webkit-autofill": {
		WebkitBoxShadow: "0 0 0 1000px white inset",
	},
	"& label.Mui-focused": {
		color: "#292929",
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#292929",
		},
		"&:hover fieldset": {
			borderColor: "#292929",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#e60b13",
		},
	},
});


function PasswordRequestForm(props){
    return(
        <StyledEngineProvider injectFirst>
			<Link to="/login">
				<Box
					float="left"
					display="flex"
					margin="1rem 0 0 1rem"
					alignItems="center"
				>
					<ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
					<Typography variant="subtitle2" color="initial" ml={1}>
                        Volver a Inicio de Sesión
					</Typography>
				</Box>
			</Link>
			<Container
				maxWidth="xs"
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					alignItems: "center",
					height: "calc(100vh - 38px)",
					color: "#292929",
					paddingTop: 3,
					paddingBottom: 3,
				}}
			>
				<Box component="div" sx={{ height: "fit-content", minWidth: 400 }}>
					<Link to="/">
						<img src={logo} alt="Logo Grupo Monaco" className="login-logo" />
					</Link>
					<Box
						component="form"
						onSubmit={props.handleSubmit}
						sx={{ textAlign: "center" }}
						autoComplete="on"
					>
						<Typography
							component="h1"
							variant="h5"
							sx={{ fontSize: "1rem", fontFamily: "Quicksand" }}
						>
							SOLICITUD NUEVA CONTRASEÑA
						</Typography>
						{props.dataRequestNewPassword.map((field, index) => {
							return(
								<Fragment key={field.id}>
									<LoginTextField
										id={field.id}
										name={field.id}
										type={field.type}
										label={field.label}
										value={props.dataRequestNewPassword[index].value}
										onChange={props.handleChange}
										variant="outlined"
										margin="normal"
										fullWidth
										onPaste={props.disablePaste}
									/> 
									<Typography sx={{ textAlign: "left" }} variant="body1" color="error">
										{props.dataRequestNewPassword[index].error}
									</Typography> 
								</Fragment>
							)})
						}
						<Button
							type="submit"
							color="brand"
							fullWidth
							variant="contained"
							sx={{
								mt: 2,
								fontSize: "1rem",
								fontWeight: 700,
								textTransform: "none",
								marginBottom: "0.7rem"
							}}
							style={{ fontFamily: "Quicksand" }}
						>
							Enviar
						</Button>
					</Box>
				</Box>
			</Container>
		</StyledEngineProvider>
    )
}

export default PasswordRequestForm;